import axios from 'axios'

export default {

    /**
     * Get category nodes.
     * @param params
     * @returns {AxiosPromise<any>}
     */
    get(params = {}) {
        /* TODO rename to category-nodes */
        return axios.get('/api/categories', { params })
    },

    /**
     * Find category by id.
     * @param id
     * @returns {AxiosPromise<any>}
     */
    find(id) {
        /* TODO rename to category-nodes */
        return axios.get('/api/categories/' + id)
    },

    /**
     * Get categories by type.
     * @param type
     * @returns {AxiosPromise<any>}
     */
    getByType(type) {
        /* TODO rename to categories */
        return axios.get('/api/cats', { params: { type: type } })
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/api/categories.js